<template>
	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4 class="margin-b-24">Afronden</h4>
		<p>Bent u op plaats van bestemming? Dan kunt u deze oproep aftekenen</p>
		<div class="margin-b-24" v-if="deliveryData.completed" >
			<i>Afgerond op: {{datestring(deliveryData.completed)}}</i>
		</div>
		<div v-if="deliveryData.completed && deliveryData.comment">
			<i>{{deliveryData.comment}}</i>
		</div>
		<div v-if="!deliveryData.completed" class="c-complete__button">
			<button class="c-btn c-btn--expanded c-btn--hollow no-margin" @click="trigger('finish-delivery')">
				Afronden
			</button>
		</div>
	</div>
</template>

<script>

export default {
	data() {
		return {
			deliveryData: []
		}
	},
	props: {
		delivery: {
			required: true
		}
	},
	methods: {
		trigger(event) {
			this.$store.dispatch('listener/emit', event);
		},
		datestring(value) {
			if ( typeof value == 'string' && value.trim() != '' ) {
			let date = new Date(value);

				if ( isNaN(date.getTime()) === false ) {

					return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric'})
							+ ' ' + date.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }) + " uur";

				}
    		}   
		},
		load(delivery){
			this.deliveryData = delivery;
		}
	},
	mounted(){
		this.deliveryData = this.delivery;
	}
}
</script> 